/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberSquareSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M148,148a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,148ZM224,48V208a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,48,32H208A16.01833,16.01833,0,0,1,224,48ZM164,148a36.04061,36.04061,0,0,0-36-36q-.91517,0-1.81909.04614l16.68823-27.95141a8,8,0,0,0-13.73828-8.20118L96.88574,129.90137c-.06152.103-.11035.20984-.16675.31445A35.99282,35.99282,0,1,0,164,148Z" />
    </Svg>
  );
}

export default NumberSquareSix;
